
import * as React from "react"
import * as SeparatorPrimitive from "@radix-ui/react-separator"

import { cn } from "@/lib/utils"

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
    gradient?: "purple" | "teal" | "orange" | "primary" | null;
  }
>(
  (
    { className, orientation = "horizontal", decorative = true, gradient = null, ...props },
    ref
  ) => {
    let gradientClass = "";
    
    if (gradient === "purple") {
      gradientClass = "bg-gradient-to-r from-purple-600 to-pink-500";
    } else if (gradient === "teal") {
      gradientClass = "bg-gradient-to-r from-blue-500 to-teal-500";
    } else if (gradient === "orange") {
      gradientClass = "bg-gradient-to-r from-orange-500 to-amber-500";
    } else if (gradient === "primary") {
      gradientClass = "bg-gradient-to-r from-zuiver-primary to-[#9b87f5]";
    }
    
    return (
      <SeparatorPrimitive.Root
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={cn(
          "shrink-0",
          orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
          gradientClass || "bg-border",
          className
        )}
        {...props}
      />
    );
  }
)
Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator }
